<template>
  <div>
    <v-row dense style="min-height: 38px;" class="my-0">
      <v-col cols="4" align-self="center" align="right" class="text-body-2 text-break">
        <slot name = "name"/>
      </v-col>
      <v-col cols="8" align-self="center">
        <slot/>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {

  name: 'EditorPropertiesRow'

}

</script>

<style scoped>

</style>
